import { IDonationParams, ISaveAwardInfo } from "@/props/IDonation";
import request from "@/utils/request";

/**
 * 获取活动信息
 * @param {*} params
 * @returns
 */
export function getEventInfo(id: number) {
  return request({
    url: `/front/events/event/${id}`,
    method: "GET",
  });
}

/**
 * 获取捐赠比率
 * @param {*} params
 * @returns
 */
export function getDonationRates(params: { eventId: number }) {
  return request({
    url: "/front/donations/rates/rate",
    method: "GET",
    params,
  });
}

/**
 * 跑马灯
 * @param {*} params
 * @returns
 */
export function getDonationlatestRecords(params: { limit?: number; eventId: number }) {
  return request({
    url: "/front/donations/records/latest",
    method: "GET",
    params,
  });
}

/**
 * 捐赠
 * @param {*} params
 * @returns
 */
export function donateDreamPoints(params: IDonationParams) {
  return request({
    url: "/front/donations/records/donate",
    method: "POST",
    data: params,
  });
}

/**
 * 获取捐赠信息  IB & Client
 * @param {*} params
 * @returns
 */
export function getDonationStates(params: { eventId: number }) {
  return request({
    url: "/front/donations/amount/summary/user/stats",
    method: "GET",
    params,
  });
}

/**
 * 获取IB下面的用户捐赠信息，可搜索
 * @param {*} params
 * @returns
 */
export function getIBDonationList(params: { page?: number; limit?: number; offset?: number; searchValue?: string }) {
  return request({
    url: "/front/donations/records/ib/clients",
    method: "GET",
    params,
  });
}

/**
 * 获取捐赠排行榜
 * @param {*} params
 * @returns
 */
export function getDonationLeaderBoard(params: { page?: number; limit?: number; offset?: number }) {
  return request({
    url: "/front/donations/ib/rank/leaderboard",
    method: "GET",
    params,
  });
}

/**
 * 用户捐赠记录
 * @param {*} params
 * @returns
 */
export function userDonationsListApi(params: { page?: number; limit?: number; offset?: number; type?: number | null }) {
  return request({
    url: "/front/donations/records/list",
    method: "GET",
    params,
  });
}

// ib & client 获取捐赠信息
export function getAward(id: number) {
  return request({
    url: `/front/donations/award/getAward/${id}`,
    method: "GET",
  });
}

// ib & client 保存获奖信息
export function saveAward(params: ISaveAwardInfo) {
  return request({
    url: "/front/donations/award/saveAward",
    method: "POST",
    data: params,
  });
}
